// @ts-nocheck
import React, { useEffect, useRef } from "react";
import { Tooltip } from "bootstrap";

/**
 * @typedef PermissionProceduresTooltipProperties
 * @property {number} permissionObjectId
 * @property {number} permissionKind
 * @property {IPermissionMatrix} matrix
 */

/**
 * @param {PermissionProceduresTooltipProperties} param0
 */
export default function PermissionProceduresTooltip({ permissionObjectId, permissionKind, matrix })
{
    const ref = useRef(null);
    const operations = matrix.getOperations(permissionObjectId, permissionKind);
    // const procedures = matrix.objectRights.get(permissionObjectId)?.get(permissionKind) ?? [];
    const operationsNames = operations.map(entity => entity.name).filter(p => p);
    const title = operationsNames.map(name => `<div>${name}</div>`).join('');

    useEffect(() =>
    {
        if (!ref.current) { return; }
        const tooltip = new Tooltip(ref.current,
        {
            title: title,
            // Use auto placement to avoid jitter on narrow space
            placement: 'auto',
            trigger: 'hover focus',
            container: 'body',
            html: true,
            // Add a slight delay to prevent rapid hide/show flicker
            delay: { show: 100, hide: 200 },
            // Bootstrap 4-compatible options
            boundary: 'viewport',
            offset: '0,8'
        });
        return () => {
            try { tooltip.hide(); } catch (e) { /* empty */ }
            try { tooltip.dispose(); } catch (e) { /* empty */ }
        };
    },
    [permissionObjectId, permissionKind, matrix]);

    const element =
    <i
        ref={ref}
        className={`fa fa-info-circle text-muted ms-1 crud-icon`}
        tabIndex={0}
        role="button"
        aria-label="Info"
    />;
    return element;
}